'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _auth = require('redux/actions/auth');

var _modal = require('redux/actions/modal');

var _modal_type = require('redux/actions/modal_type');

var _pass_recovery = require('redux/actions/pass_recovery');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Auth = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        loginError: state.auth.loginError,
        loginErrorCode: state.auth.loginErrorCode,
        user: state.auth.user,
        preload: state.auth.preload,
        shopId: state.setting.shopId,
        googleCaptcha: state.setting.googleCaptcha,
        googleCaptchaSitekey: state.setting.googleCaptchaSitekey,
        lang: state.lang
    };
}, { login: _auth.login, hide: _modal.hide, showModalRegistration: _modal_type.showModalRegistration, resetError: _auth.resetError, showModalPassRecovery: _modal_type.showModalPassRecovery, sendPhoneToReducer: _pass_recovery.sendPhoneToReducer, resetStep: _pass_recovery.resetStep }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(Auth, _BaseForm);

    function Auth(props) {
        (0, _classCallCheck3.default)(this, Auth);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Auth.__proto__ || (0, _getPrototypeOf2.default)(Auth)).call(this, props));

        _this.validateField = function (field) {
            // if(this.state[field].length > 0){
            //     return 'success';
            // }
            //
            // return 'error';
        };

        _this.onClickRegistration = function (event) {
            _this.props.showModalRegistration(_this.props.lang);
        };

        _this.onClickPassRecovery = function (event) {
            _this.props.resetStep();
            _this.props.sendPhoneToReducer(_this.state.login);
            _this.props.showModalPassRecovery(_this.props.lang);
        };

        _this.onSuccessCaptcha = function (value) {
            _this.setState({ captcha: value });
        };

        _this.showCaptcha = function () {
            if (_this.props.googleCaptcha) {
                setTimeout(function () {
                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
                }, 500);
                // return (
                //     <Recaptcha
                //         sitekey={this.props.googleCaptchaSitekey}
                //         render="explicit"
                //         onChange={this.onSuccessCaptcha}
                //     />
                // );
            }

            return '';
        };

        _this.state = {
            login: '',
            password: '',
            captcha: null,
            needCaptcha: true
        };
        return _this;
    }

    (0, _createClass3.default)(Auth, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.loginError && nextProps.loginErrorCode === 'user.errorInvalidCaptcha') {
                this.setState({ needCaptcha: true });
            }

            if (nextProps.user && (nextProps.user.phone || nextProps.user.email)) {
                this.setState({ login: '', password: '' });
                this.props.hide();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetError();
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.state.login.length > 0 && this.state.password.length > 0;
        }
    }, {
        key: 'onSubmit',


        /**
         * @param {SyntheticMouseEvent} event
         */
        value: function onSubmit(event) {
            event.preventDefault();
            if (this.props.googleCaptcha && this.state.captcha == null) {
                var alertMessage = this.props.lang['user.errorInvalidCaptcha'];
                setTimeout(function () {
                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                }, 0);
                return null;
            }
            this.props.login({ login: this.state.login, password: this.state.password, captcha: this.state.captcha, callback: null, shopId: this.props.shopId });
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('Auth');
            return _react2.default.createElement(View, { loginError: this.props.loginError,
                validateField: this.validateField,
                changeField: this.changeField,
                onSubmit: this.onSubmit,
                onClickRegistration: this.onClickRegistration,
                onClickPassRecovery: this.onClickPassRecovery,
                disabledSubmit: !this.isValid(),
                login: this.state.login,
                password: this.state.password,
                preload: this.props.preload,
                showCaptcha: this.showCaptcha,
                loginErrorCode: this.props.loginErrorCode,
                lang: this.props.lang
            });
        }
    }]);
    return Auth;
}(_BaseForm3.default), _class2.propTypes = {
    showModalRegistration: _react.PropTypes.func.isRequired,
    resetError: _react.PropTypes.func.isRequired,
    hide: _react.PropTypes.func.isRequired,
    lang: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Auth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/Auth.jsx
// module id = 1603
// module chunks = 0